import angular from 'angular';

module.exports = angular.module('market.routes', [
  require('angular-ui-router'),
  require('./dashboard'),
  require('./humans'),
  require('./market-chart'),
  require('./offer-terms'),
  require('./postcard-terms'),
  require('./properties'),
  require('./property-terms'),
  require('./repairs'),
  require('./static'),
  require('./ugc-terms'),
  require('./unsubscribed-customer'),
  require('./vendor-help'),
  require('./verify'),
])
.config(function($stateProvider, ngMetaProvider) {
  $stateProvider.decorator('data', ngMetaProvider.mergeNestedStateData);
  ngMetaProvider.setDefaultTitle('Opendoor');
  ngMetaProvider.setDefaultTag(
    'description',
    'Opendoor makes you a free offer on your home today, so you can sell on your schedule.'
  );
  ngMetaProvider.useTitleSuffix(true);
  $stateProvider.state('root', {
    url: '',
    abstract: true,
    views: {
      '@': { template: '<div ui-view></div>' },
      'header@': {}, // keep using the default header rendered by rails
      'header_xs_down@': {}, // keep using the default header rendered by rails
      'footer@': {},  // keep using the default footer rendered by rails
      'footer_xs_down@': {}, // keep using the default footer rendered by rails
    },
    resolve: {
      // this ensures any controller who accesses $rootScope.session will have a resolved
      // session before that router is run.
      resolveCurrentSession: $rootScope => $rootScope.session.$promise
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/index.js
 **/